import { render, staticRenderFns } from "./InheritedTextHint.vue?vue&type=template&id=4ef7d6ae&scoped=true&"
import script from "./InheritedTextHint.vue?vue&type=script&lang=js&"
export * from "./InheritedTextHint.vue?vue&type=script&lang=js&"
import style0 from "./InheritedTextHint.vue?vue&type=style&index=0&id=4ef7d6ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef7d6ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
